export default __webpack_public_path__ + "static/media/friend-by-friend-coffee.4393e212.webp";